import { createFileRoute } from '@tanstack/react-router';

import Loading from '@/_pages/settings/recruiting-hiring-criteria-categories/new/loading';

export const Route = createFileRoute('/_private/settings/recruiting-hiring-criteria-categories/new')({
  component: Loading,
});
